import async from 'async';
import moment from 'moment';
import feathers from '../../feathers';

var magic = {
  quotationUserId: (UserId, dateInitial, dateFinish) => {
    return new Promise(async function (resolve, reject) {
      const dataReport = {
        userId: UserId,
        dateInitial: dateInitial,
        dateFinish: dateFinish,
      };

      var resultQuotation = await feathers
        .service('quotation-magic-report')
        .create(dataReport);
      var dataQuotation = {
        total: resultQuotation.totalQuotations,
        count: resultQuotation.countQuotations,
      };

      resolve(dataQuotation);
    });
  },

  salesUserId: (UserId, dateInitial, dateFinish) => {
    return new Promise(async function (resolve, reject) {
      var resultSales = await feathers.service('sales').find({
        query: {
          assignedTo: UserId,
          $nor: [{ delete: 'true' }],
          dateSaleNote: {
            $gte: new Date(moment(dateInitial).startOf('day')),
            $lte: new Date(moment(dateFinish).endOf('day')),
          },
          $limit: 100000,
          $populate: 'assignedTo',
          'balance.totalDebit': 0,
        },
      });

      var dataSale = {
        SaleTotal: 0,
        SaleCount: resultSales.data.length,
        SaleCommissions: 0,
      };

      async.forEach(
        resultSales.data,
        function (s, callbackSale) {
          if (s.balance.totalPrice) {
            dataSale.SaleTotal += s.balance.totalPrice - 0;
            dataSale.SaleCommissions += s.balance.commissions - 0;
            callbackSale();
          } else {
            callbackSale();
          }
        },
        function () {
          resolve(dataSale);
        }
      );
    });
  },
};

export default magic;



// WEBPACK FOOTER //
// ./src/views/ReportSales/magicReport.js